<div #dropdownButton class="dropdown" dropdown [dropup]="isDropup()" [container]="renderIndBody() ? 'body' : undefined">
  <button class="btn btn-secondary dropdown-toggle w-100" dropdownToggle type="button" data-toggle="dropdown">
    <span class="d-inline-flex text-start w-100 pe-2">
      <span class="flex-grow-1 label">{{ label() + (selectedItem() ? ":" : "") }}</span>
      <span class="ps-2 selected-item" style="text-overflow: ellipsis;">{{ (selectedItem() ? selectedItem() : "") }}</span>
    </span>
  </button>
  <div *dropdownMenu class="dropdown-menu" [style.width.px]="dropdownButton.offsetWidth" [class.dropup]="isDropup()">
    <ng-scrollbar style="max-height: 300px;" [autoHeightDisabled]="false">
      @for (item of items(); track item) {
        <a class="dropdown-item p-1" (click)="selectItem(item)">
          @if (item) {
            @if (itemIcon(); as itemIcon) {
              <app-svg-icon class="d-inline-block me-2" [type]="itemIcon"/>
            }
            <span>{{ item }}</span>
          } @else {
            <app-svg-icon class="d-inline-block me-2" type="close"/>
          }
        </a>
      }
    </ng-scrollbar>
  </div>
</div>
